import { db } from "~/plugins/firebase";

export const specialistsCollection = db.collection("specialists");
export const prefecturesCollection = db.collection("prefectures");
export const contactsCollection = db.collection("contacts");
export const businessesCollection = db.collection("businesses");
export const categoriesCollection = db.collection("categories");
export const notificationsCollection = db.collection("notifications");
export const questionsCollection = db.collection("questions");
export const helpsCollection = db.collection("helps");
